import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, Type } from '@angular/core';
import { GaWizardService } from '../../../shared/wizard/ga-wizard.service';
import { WIZARD_BP_PROFILES } from '../../../shared/app-wizards';
import { BPProfileListType, BPProfileSecuredDomain, BPProfilesService, BPProfileWizardAction } from '../bp-profiles.service';
import { BPProfilesDataService } from '../bp-profiles-data.service';
import { IBPProfile, IBPProfileBasic, IExtendedWindow } from '../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { DialogSize, GaMessageService, IDialog, IDialogButton } from '../../../shared/message/ga-message.service';
import { TranslationService } from '../../../shared/translation/translation.service';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { GaWizard, IWizardButton, IWizardStep } from '../../../shared/wizard/ga-wizard';
import { BPProfilesProductCatalogComponent } from './product-catalog/bp-profiles-product-catalog.component';
import {
  STATE_BPPROFILES_ACCESS_SETTINGS,
  STATE_BPPROFILES_VENDOR_ACCREDITATIONS,
  STATE_BPPROFILES_ACSLINFO,
  STATE_BPPROFILES_AUDIT,
  STATE_BPPROFILES_BANK,
  STATE_BPPROFILES_BP_KPI,
  STATE_BPPROFILES_CATALOG_DETAIL,
  STATE_BPPROFILES_CATALOG_OVERVIEW,
  STATE_BPPROFILES_CAVEATS,
  STATE_BPPROFILES_CHECKLISTS,
  STATE_BPPROFILES_CONTACTS,
  STATE_BPPROFILES_CONTRACT,
  STATE_BPPROFILES_DOCUMENTS,
  STATE_BPPROFILES_GENERAL,
  STATE_BPPROFILES_INVOICEDETAIL,
  STATE_BPPROFILES_INVOICEOVERVIEW,
  STATE_BPPROFILES_LBDM_CHECKLIST,
  STATE_BPPROFILES_LESSORCONFIG,
  STATE_BPPROFILES_LOCATIONS,
  STATE_BPPROFILES_MAILS,
  STATE_BPPROFILES_OEM_DETAIL,
  STATE_BPPROFILES_OEM_OVERVIEW,
  STATE_BPPROFILES_ORDER_KPI,
  STATE_BPPROFILES_PLATFORMCONFIG,
  STATE_BPPROFILES_PRODUCTCATALOG,
  STATE_BPPROFILES_SLA,
  STATE_BPPROFILES_SURVEY,
  STATE_BPPROFILES_TC,
  STATE_BPPROFILES_TERRITORIES,
  STATE_BPPROFILES_TICKETS,
  STATE_BPWIZARD_GENERAL,
  STATE_HOME_PAGE,
  STATE_BPPROFILES_INTERNAL_CONFIG,
  STATE_BPPROFILES_ENGINEER_ACCREDITATIONS
} from '../../../shared/app-states';
import { StateService, TransitionService, StateDeclaration } from '@uirouter/angular';
import { BPProfilesRelationsComponent } from './bp-relations/bp-profiles-relations.component';
import { GaEventService, IGAEvent } from '../../../shared/services/ga-event.service';
import { EVENT_PERMISSIONS_SELECTED } from '../../../shared/app-events';
import { Subscription } from 'rxjs';
import { BPProfilesReportDialogComponent } from './bp-profiles-report-dialog.component';
import { FormattingService } from '../../../shared/services/formatting.service';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { UrlService } from '../../../shared/browser/url.service';
import { BPProfilesGeneralInfoComponent } from './general-info/bp-profiles-general-info.component';
import { BUTTON_SAVE } from '../../../shared/message/dialogs/default-form-dialog.component';
import { GaDeferredService, IGADeferred } from '../../../shared/services/ga-deferred.service';
import { BPProfilesBankComponent } from './bank/bp-profiles-bank.component';
import { BPProfilesAccessSettingsComponent } from './access-settings/bp-profiles-access-settings.component';
import { BPProfilesAcslInfoComponent } from './acsl-info/bp-profiles-acsl-info.component';
import { BPProfilesContactsComponent } from './contacts/bp-profiles-contacts.component';
import { BPProfilesOEMOverviewComponent } from './oem/bp-profiles-oem-overview.component';
import { BPProfilesSurveyComponent } from './survey/bp-profiles-survey.component';
import { BPProfilesDashboardComponent } from './dashboard/bp-profiles-dashboard.component';
import { BPProfilesLocationsComponent } from './locations/bp-profiles-locations.component';
import { BPProfilesAccreditationsComponent } from './accreditations/bp-profiles-accreditations.component';
import { BPProfilesDocumentsComponent } from './documents/bp-profiles-documents.component';
import { BPProfilesAuditComponent } from './audit/bp-profiles-audit.component';
import { BPProfilesCatalogOverviewComponent } from './catalog/bp-profiles-catalog-overview.component';
import { GaWebStorageService } from '../../../shared/services/storage/ga-web-storage.service';
import { BPProfilesTicketsComponent } from './tickets/bp-profiles-tickets.component';
import { BPProfilesInvoiceOverviewComponent } from './invoice/bp-profiles-invoice-overview.component';
import { BPProfilesMailsComponent } from './mails/bp-profiles-mails.component';
import { BPProfilesTerritoriesComponent } from './territories/bp-profiles-territories.component';
import { BPProfilesTCComponent } from './tc/bp-profiles-tc.component';
import { BPProfilesContractComponent } from './contract/bp-profiles-contract.component';
import { BPProfilesCaveatsComponent } from './caveats/bp-profiles-caveats.component';
import { BPProfilesSLAComponent } from './sla/bp-profiles-sla.component';
import { BPProfilesChecklistsComponent } from './checklists/bp-profiles-checklists.component';
import { MaxWidth, ResponsiveService } from '../../../shared/responsive/responsive.service';
import { BPProfilesInternalConfigComponent } from './internal-config/bp-profiles-internal-config.component';

enum BPProfilesWizardStep {
  GENERAL_INFO = 'generalInfo',
  BANK = 'bank',
  ACCESS_SETTINGS = 'accessSettings',
  PRODUCT_CATALOG = 'productCatalog',
  CATALOG = 'catalog',
  LESSOR_CONFIG = 'lessorConfig',
  PLATFORM_CONFIG = 'platformConfig',
  ACSL_INFO = 'acslInfo',
  CONTACTS = 'contacts',
  LOCATIONS = 'locations',
  OEM = 'oem',
  SURVEY = 'survey',
  VENDOR_ACCREDITATIONS = 'vendorAccreditations',
  ENGINEER_ACCREDITATIONS = 'engineerAccreditations',
  LBDM_CHECKLIST = 'lbdmChecklist',
  AUDIT = 'audit',
  ORDER_KPI = 'orderKPI',
  BP_KPI = 'bpKPI',
  DOCUMENTS = 'documents',
  TICKETS = 'tickets',
  INVOICE = 'invoice',
  MAILS = 'mails',
  TERRITORIES = 'territories',
  TC = 'tc',
  CONTRACT = 'contract',
  CAVEATS = 'caveats',
  SLA = 'sla',
  PROFILE_CHECKLIST = 'profileChecklist',
  INTERNAL_CONFIG = 'internalConfig'
}

interface IProfileSelectionModel {
  profileSelection?:IBPProfileBasic;
}

const BP_VIEW_CODE_PERMISSION:string = 'bp';
const BUTTON_DISCARD:string = 'discard';
const BUTTON_CONTINUE:string = 'continue';

@Component({
  selector: 'bp-profiles-advanced',
  template: `
    <h2 *ngIf="loading"><activity-indicator [useDefaultText]="true"></activity-indicator></h2>
    
    <div *ngIf="!loading">
      <wizard-wrapper [loading]="loading" [wizardTitle]="title" [error]="error" [wizardId]="wizardId">
        <div class="wizard-header-extra" *ngIf="showCustomWizardHeader">
          <formly [form]="form" [fields]="fields" [model]="model"></formly>
        </div>
      </wizard-wrapper>
    </div>
  `
})
export class BPProfilesAdvancedComponent implements OnInit, OnChanges, OnDestroy  {
  @Input() public profileListType:BPProfileListType;
  @Input() public profileId:string|number;
  @Input() public hideWizardEditButton:boolean;

  public wizardId:string = WIZARD_BP_PROFILES;
  public loading:boolean;
  public title:string;
  public error:string;
  public showCustomWizardHeader:boolean;
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public model:IProfileSelectionModel = {};
  public fields:IExtraFieldConfigurationObject[] = [];

  private wizard:GaWizard;
  private eventSubscription:Subscription;
  private onActiveProfileChangeSubscription:Subscription;
  private onSaveBusySubscription:Subscription;
  private onDisableProfileSelectionSubscription:Subscription;
  private onEditChangeSubscription:Subscription;
  private onSavingErrorSubscription:Subscription;
  private onStateSuccessHandler:Function;
  private profileSelectionField:IExtraFieldConfigurationObject;
  private confirmationDialog:IDialog;
  private confirmationDialogDeferred:IGADeferred<boolean>;
  // indicate that the saving comes from wizard action
  private wizardSaving:boolean;

  constructor(
    private formlyService:GaFormlyService,
    private wizardService:GaWizardService,
    private bpProfilesService:BPProfilesService,
    private bpProfilesDataService:BPProfilesDataService,
    private messageService:GaMessageService,
    private translationService:TranslationService,
    private webStorage:GaWebStorageService,
    private authService:AuthService,
    private uiRouterStateService:StateService,
    private transitionService:TransitionService,
    private eventService:GaEventService,
    private urlService:UrlService,
    private formattingService:FormattingService,
    private deferredService:GaDeferredService,
    private responsiveService:ResponsiveService,
    @Inject(Window) private window:IExtendedWindow
  ) {
    responsiveService.width = MaxWidth.MD;
  }

  public ngOnInit():void {
    this.wizard = this.wizardService.getInstance(WIZARD_BP_PROFILES);
    this.bpProfilesService.editConfirmationDialogFn(this.onBeforeStepsChange);

    if (!this.bpProfilesService.allProfiles?.length) {
      this.loading = true;
      this.bpProfilesDataService.getBPProfiles()
        .then(this.filterProfiles)
        .then(this.initWizard)
        .then(this.createFields)
        .finally(() => {
          this.onProfileSelectionChange(this.bpProfilesService.activeProfile);
          this.syncWizard();
          this.loading = false;
        });
    } else {
      this.selectDefaultProfile();
      this.onActiveProfileChange();
      this.initWizard()
        .then(this.createFields)
        .finally(() => {
          this.onProfileSelectionChange(this.bpProfilesService.activeProfile);
          this.syncWizard();
        });
    }

    // register listener
    this.listen();
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.profileId) {
      this.profileId = changes.profileId.currentValue;
    }

    if (changes.profileListType) {
      this.profileListType = changes.profileListType.currentValue;
    }

    if (changes.hideWizardEditButton) {
      this.onHideWizardEditButtonChange(changes.hideWizardEditButton.currentValue);
    }
  }

  private listen():void {
    // when state change successfully then we need to reload translation modules
    this.onStateSuccessHandler = this.transitionService.onSuccess({}, () => {
      this.checkHideWizardEditButton();
    });

    this.onActiveProfileChangeSubscription = this.bpProfilesService.onActiveProfileChange.subscribe(this.onActiveProfileChange);
    this.eventSubscription = this.eventService.events.subscribe((event:IGAEvent) => {
      if (event.name === EVENT_PERMISSIONS_SELECTED) {
        this.checkPermissions();
      }
    });
    this.onEditChangeSubscription = this.bpProfilesService.onEditChange.subscribe(this.onEditChange);
    this.onSaveBusySubscription = this.bpProfilesService.onSaveBusy.subscribe(this.saveButtonBusyFunction);
    this.onDisableProfileSelectionSubscription = this.bpProfilesService.onDisableProfileSelection.subscribe(this.onDisableProfileSelection);
    this.onSavingErrorSubscription = this.bpProfilesService.onSavingError.subscribe(this.onSavingError);
  }

  private onHideWizardEditButtonChange(isHidden:boolean):void {
    this.hideWizardEditButton = !!isHidden;
    this.wizard.setActionVisible(BPProfileWizardAction.EDIT, !this.hideWizardEditButton);
  }

  private checkHideWizardEditButton():void {
    // we hide 'edit' wizard button when it's definitive via uiRouter config or user doesn't have 'write' permission
    const hasWritePermission:boolean = this.authService.viewWrite(this.uiRouterStateService.current.data?.viewCode);
    this.onHideWizardEditButtonChange(this.bpProfilesService.editingMode || this.uiRouterStateService.current.data?.hideWizardEditButton || !hasWritePermission);
  }

  private initWizard = ():Promise<void> => {
    // mark wizard should have sidebar navigation
    this.wizard.hasSidebarNavigation = true;

    this.createWizardSteps();
    this.createWizardActions();
    return Promise.resolve();
  };

  private createWizardSteps():void {
    const createWizardStep = (id:string, wizardMenuTitle:string, component:Type<any>, stateName:string, stateChildren?:string[]):IWizardStep => {
      return this.wizardService.createStep(id, wizardMenuTitle, component, stateName, undefined, stateChildren, true);
    };

    this.wizard.steps([
      createWizardStep(BPProfilesWizardStep.GENERAL_INFO, 'BPPROFILES.GENERAL_INFO.TEXT', BPProfilesGeneralInfoComponent, STATE_BPPROFILES_GENERAL),
      createWizardStep(BPProfilesWizardStep.PROFILE_CHECKLIST, 'BPPROFILES.PROFILE_CHECKLIST.TITLE', BPProfilesChecklistsComponent, STATE_BPPROFILES_CHECKLISTS),
      createWizardStep(BPProfilesWizardStep.LBDM_CHECKLIST, 'BPPROFILES.LBDM_CHECKLIST.TEXT', BPProfilesDashboardComponent, STATE_BPPROFILES_LBDM_CHECKLIST),
      createWizardStep(BPProfilesWizardStep.BANK, 'BPPROFILES.BANK.TEXT', BPProfilesBankComponent, STATE_BPPROFILES_BANK),
      createWizardStep(BPProfilesWizardStep.ACCESS_SETTINGS, 'BPPROFILES.ACCESS_SETTINGS.TEXT', BPProfilesAccessSettingsComponent, STATE_BPPROFILES_ACCESS_SETTINGS),
      createWizardStep(BPProfilesWizardStep.CONTACTS, 'BPPROFILES.CONTACTS.TEXT', BPProfilesContactsComponent, STATE_BPPROFILES_CONTACTS),
      createWizardStep(BPProfilesWizardStep.LOCATIONS, 'BPPROFILES.LOCATIONS.TEXT', BPProfilesLocationsComponent, STATE_BPPROFILES_LOCATIONS),
      createWizardStep(BPProfilesWizardStep.SLA, 'BPPROFILES.SLA.TEXT', BPProfilesSLAComponent, STATE_BPPROFILES_SLA),
      createWizardStep(BPProfilesWizardStep.TC, 'BPPROFILES.TC.TEXT', BPProfilesTCComponent, STATE_BPPROFILES_TC),
      createWizardStep(BPProfilesWizardStep.CAVEATS, 'BPPROFILES.CAVEATS.TEXT', BPProfilesCaveatsComponent, STATE_BPPROFILES_CAVEATS),
      createWizardStep(BPProfilesWizardStep.OEM, 'BPPROFILES.OEM.TEXT', BPProfilesOEMOverviewComponent, STATE_BPPROFILES_OEM_OVERVIEW, [STATE_BPPROFILES_OEM_OVERVIEW, STATE_BPPROFILES_OEM_DETAIL]),
      createWizardStep(BPProfilesWizardStep.VENDOR_ACCREDITATIONS, 'BPPROFILES.ACCREDITATIONS.TEXT', BPProfilesAccreditationsComponent, STATE_BPPROFILES_VENDOR_ACCREDITATIONS),
      createWizardStep(BPProfilesWizardStep.ENGINEER_ACCREDITATIONS, 'BPPROFILES.ENGINEER_ACCREDITATIONS.TEXT', BPProfilesAccreditationsComponent, STATE_BPPROFILES_ENGINEER_ACCREDITATIONS),
      createWizardStep(BPProfilesWizardStep.INTERNAL_CONFIG, 'BPPROFILES.INTERNAL_CONFIG.TEXT', BPProfilesInternalConfigComponent, STATE_BPPROFILES_INTERNAL_CONFIG),
      createWizardStep(BPProfilesWizardStep.LESSOR_CONFIG, 'BPPROFILES.LESSOR_CONFIG.TEXT', BPProfilesRelationsComponent, STATE_BPPROFILES_LESSORCONFIG),
      createWizardStep(BPProfilesWizardStep.PLATFORM_CONFIG, 'BPPROFILES.PLATFORM_CONFIG.TEXT', BPProfilesRelationsComponent, STATE_BPPROFILES_PLATFORMCONFIG),
      createWizardStep(BPProfilesWizardStep.PRODUCT_CATALOG, 'BPPROFILES.PRODUCT_CATALOG.TEXT', BPProfilesProductCatalogComponent, STATE_BPPROFILES_PRODUCTCATALOG),
      createWizardStep(BPProfilesWizardStep.CATALOG, 'BPPROFILES.CATALOG.TEXT', BPProfilesCatalogOverviewComponent, STATE_BPPROFILES_CATALOG_OVERVIEW, [STATE_BPPROFILES_CATALOG_OVERVIEW, STATE_BPPROFILES_CATALOG_DETAIL]),
      createWizardStep(BPProfilesWizardStep.DOCUMENTS, 'BPPROFILES.DOCUMENTS.TEXT', BPProfilesDocumentsComponent, STATE_BPPROFILES_DOCUMENTS),
      createWizardStep(BPProfilesWizardStep.ACSL_INFO, 'BPPROFILES.ACSL_INFO.ACSLINFO.TITLE', BPProfilesAcslInfoComponent, STATE_BPPROFILES_ACSLINFO),
      createWizardStep(BPProfilesWizardStep.MAILS, 'BPPROFILES.MAILS.TITLE', BPProfilesMailsComponent, STATE_BPPROFILES_MAILS),
      createWizardStep(BPProfilesWizardStep.TICKETS, 'BPPROFILES.TICKETS.TITLE', BPProfilesTicketsComponent, STATE_BPPROFILES_TICKETS),
      createWizardStep(BPProfilesWizardStep.CONTRACT, 'BPPROFILES.CONTRACT.TITLE', BPProfilesContractComponent, STATE_BPPROFILES_CONTRACT),
      createWizardStep(BPProfilesWizardStep.TERRITORIES, 'BPPROFILES.TERRITORIES.TITLE', BPProfilesTerritoriesComponent, STATE_BPPROFILES_TERRITORIES),
      createWizardStep(BPProfilesWizardStep.INVOICE, 'BPPROFILES.INVOICE.TITLE', BPProfilesInvoiceOverviewComponent, STATE_BPPROFILES_INVOICEOVERVIEW, [STATE_BPPROFILES_INVOICEOVERVIEW, STATE_BPPROFILES_INVOICEDETAIL]),
      createWizardStep(BPProfilesWizardStep.SURVEY, 'BPPROFILES.SURVEY.TITLE', BPProfilesSurveyComponent, STATE_BPPROFILES_SURVEY),
      createWizardStep(BPProfilesWizardStep.AUDIT, 'BPPROFILES.AUDIT.TEXT', BPProfilesAuditComponent, STATE_BPPROFILES_AUDIT),
      createWizardStep(BPProfilesWizardStep.ORDER_KPI, 'BPPROFILES.ORDER_KPI.TEXT', BPProfilesDashboardComponent, STATE_BPPROFILES_ORDER_KPI),
      createWizardStep(BPProfilesWizardStep.BP_KPI, 'BPPROFILES.BP_KPI.TEXT', BPProfilesDashboardComponent, STATE_BPPROFILES_BP_KPI)
    ]);

    this.wizard.onBeforeStepsChange(this.onBeforeStepsChange);
  }

  private createWizardActions():void {
    const actionDropdownButtons:IWizardButton[] = [
      this.wizardService.createActionButton(BPProfileWizardAction.SETUP_WIZARD, this.translationService.instant('BPPROFILES.ACTIONS.SWITCH_SETUP_WIZARD'), undefined, this.goToSetupWizard),
      this.wizardService.createActionButton(BPProfileWizardAction.PRINT_OVERVIEW, this.translationService.instant('BPPROFILES.ACTIONS.PRINT_OVERVIEW'), undefined, this.onPrintOverviewClick, false, undefined, 'fa-print', true),
      this.wizardService.createActionButton(BPProfileWizardAction.PRINT_OVERVIEW, this.translationService.instant('BPPROFILES.ACTIONS.ACTIVATION_FORM'), undefined, this.onActivationFormClick, false, undefined, 'fa-download', true)
    ];

    this.wizard.actions([
      this.wizardService.createActionButton(BPProfileWizardAction.EDIT, this.translationService.instant('GA.BUTTONS.EDIT'), undefined, () => this.onToggleEdit(true), this.hideWizardEditButton, undefined, 'fa-pencil', true),
      this.wizardService.createActionButton(BPProfileWizardAction.CANCEL, this.translationService.instant('GA.BUTTONS.CANCEL'), 'btn-danger', this.onCancel, true),
      this.wizardService.createActionButton(BPProfileWizardAction.SAVE, this.translationService.instant('GA.BUTTONS.SAVE'), 'btn-success', this.onSave, true),
      this.wizardService.createActionButton(BPProfileWizardAction.ACTIONS, this.translationService.instant('BPPROFILES.ACTIONS.LABEL'), undefined, undefined, false, undefined, undefined, true, actionDropdownButtons)
    ]);
  }

  private syncWizard():void {
    // check if user has enough permission to edit
    this.checkHideWizardEditButton();

    _.forEach(this.wizard.steps(), (step:IWizardStep) => {
      const stepState:StateDeclaration = this.uiRouterStateService.get(step.state);
      if (stepState) {
        const isAllowed:boolean = this.authService.viewRead(stepState.data.viewCode);
        if (step.state === this.uiRouterStateService.current.name && !isAllowed) {
          this.uiRouterStateService.go(STATE_BPPROFILES_GENERAL);
        }
        // set step properties
        step.hide = !isAllowed;
        step.enabled = isAllowed;
      }
    });
    this.wizard.sync();
  }

  private createFields = ():void => {
    this.fields = [
      this.profileSelectionField = this.formlyService.aSelect2('profileSelection')
        .withoutWrapper()
        .withFormat(this.formattingService.formatBPNicknameCountry)
        .withOptions(this.bpProfilesService.allProfiles)
        .onChange(this.onProfileSelectionChange)
        .build()
    ];
  };

  private onBeforeStepsChange = ():Promise<boolean> => {
    this.confirmationDialogDeferred = this.deferredService.defer();

    if (this.bpProfilesService.editingMode) {
      const buttons:IDialogButton[] = [
        {
          id: BUTTON_SAVE,
          onClick: () => {
            _.forEach(buttons, (button:IDialogButton, index:number) => {
              if (index > 0) {
                button.disabled = true;
              } else {
                button.busy = true;
              }
            });

            this.onSave();
          },
          className: 'btn btn-success',
          label: this.translationService.instant('BPPROFILES.BUTTONS.SAVE_CHANGES')
        },
        {
          id: BUTTON_DISCARD,
          onClick: () => {
            this.onToggleEdit(false);
            this.confirmationDialog.hide();
            this.confirmationDialogDeferred.resolve(false);
          },
          label: this.translationService.instant('BPPROFILES.BUTTONS.DISCARD_CHANGES'),
          className: 'btn btn-danger'
        },
        {
          id: BUTTON_CONTINUE,
          onClick: () => {
            this.confirmationDialog.hide();
            this.confirmationDialogDeferred.resolve(true);
          },
          label: this.translationService.instant('BPPROFILES.BUTTONS.CONTINUE_EDITING'),
          className: 'btn btn-info'
        }
      ];

      this.confirmationDialog = this.messageService.showMessageDialog(
        'BPPROFILES.DIALOG.CONFIRMATION_EDIT_TITLE',
        this.translationService.instant('BPPROFILES.DIALOG.CONFIRMATION_EDIT_MSG'),
        buttons,
        undefined,
        undefined,
        DialogSize.MD
      );

      this.confirmationDialog.onHide.subscribe(() => {
        // clear deferred property when dialog close
        this.confirmationDialogDeferred = undefined;
        this.confirmationDialog = undefined;
      });

      return this.confirmationDialogDeferred.promise;
    }
  };

  private onActiveProfileChange = ():void => {
    // when formControl is not yet defined it means the form are not yet rendered
    // setting model instead to set initial value
    if (this.profileSelectionField?.formControl) {
      this.profileSelectionField.formControl.setValue(this.bpProfilesService.activeProfile);
    } else {
      this.model.profileSelection = this.bpProfilesService.activeProfile;
    }
  };

  private checkPermissions():void {
    if (!this.authService.hasViewPermission(BP_VIEW_CODE_PERMISSION)) {
      this.error = this.translationService.instant('BPPROFILES.PERMISSION.NO_ACCESS.TEXT');
    } else if (!this.authService.viewRead()) {
      this.error = this.translationService.instant('BPPROFILES.PERMISSION.NO_PERMISSION.TEXT');
    } else {
      this.error = undefined;
    }
  }

  private filterProfiles = (profiles:IBPProfile[]):Promise<void> => {
    if (profiles?.length) {
      let predicate:(profile:IBPProfile) => boolean;

      if (this.profileListType === BPProfileListType.MY_PROFILE) {
        // your writable profiles (or all, if you are an ACSL user)
        predicate = profile => profile.securedDomain === BPProfileSecuredDomain.GENERAL || profile.securedDomain ===  BPProfileSecuredDomain.INTERNAL;
      } else if (this.profileListType === BPProfileListType.OTHER) {
        // your readable profiles (or all, if you are an ACSL user)
        predicate = profile => profile.securedDomain === BPProfileSecuredDomain.READ || profile.securedDomain === BPProfileSecuredDomain.INTERNAL;
      } else {
        predicate = () => true; // no filter
      }

      this.bpProfilesService.allProfiles = _.filter(profiles, predicate);
      this.selectDefaultProfile();
    } else {
      this.bpProfilesService.allProfiles = undefined;
      this.uiRouterStateService.go(STATE_HOME_PAGE);
    }

    return Promise.resolve();
  };

  private selectDefaultProfile():void {
    if(this.bpProfilesService.allProfiles?.length) {
      let selection:IBPProfileBasic;

      if (this.profileId) {
        const bpId:string = this.profileId.toString();
        if (/^\d+$/.test(bpId)) { // when it's a regular number, use it to match the ID
          selection = _.findWhere(this.bpProfilesService.allProfiles, { id: this.profileId });
        } else if (/^cc:\d+$/.test(bpId)) { // when it's 'cc:xxx', use it to match the companyCountryId
          const companyCountryId:number = Number(bpId.replace(/cc:/, ''));
          selection = _.findWhere(this.bpProfilesService.allProfiles, { companyCountryId });
        }

        if (selection) {
          this.bpProfilesService.activeProfile = selection;
          this.profileId = selection?.id;
        } else {
          this.error = this.translationService.instant('GA.GENERAL.NOT_FOUND', { label: this.translationService.instant('GA.GENERAL.BP_PROFILE')} );
          this.uiRouterStateService.go(STATE_HOME_PAGE);
        }
      } else {
        const idToSelect:number = this.webStorage.local.get(`ga2.${this.profileListType}.profileId`); //from localStorage
        selection = _.findWhere(this.bpProfilesService.allProfiles, { id: idToSelect });
        this.bpProfilesService.activeProfile = (selection || this.bpProfilesService.allProfiles[0]);
      }
    } else {
      this.bpProfilesService.activeProfile = undefined;
    }

    this.showCustomWizardHeader = this.bpProfilesService.allProfiles?.length > 1;
  }

  private onProfileSelectionChange = (profileSelection:IBPProfileBasic):void => {
    this.bpProfilesService.activeProfile = profileSelection;

    if (profileSelection) {
      // clear profile detail if exist and new selection is not the same with current one
      if (this.bpProfilesService.profileDetail && profileSelection?.id !== this.bpProfilesService.profileDetail?.id) {
        this.bpProfilesService.profileDetail = undefined;
      }
      this.title = this.formattingService.formatBPNicknameCountry(profileSelection);
      this.authService.selectPermissions(profileSelection.securedDomain);
      this.webStorage.local.set(`ga2.${this.profileListType}.profileId`, profileSelection.id);
      //persist the selected profile id in the url (this will reload the controller)
      //the abstract check will only be true in unit test context
      if (!this.uiRouterStateService.current.abstract) {
        this.uiRouterStateService.go(this.uiRouterStateService.current.name, { profileId: profileSelection.id });
      }
    } else {
      this.authService.selectPermissions();
    }

    if (!profileSelection) {
      this.bpProfilesService.activeProfile = undefined;
    }
  };

  private onDisableProfileSelection = (isDisabled?:boolean):void => {
    // disable profile selection field when edit mode is true
    this.profileSelectionField.templateOptions.disabled = isDisabled;
  };

  private onEditChange = (isEdit:boolean):void => {
    this.wizard.setActionVisible(BPProfileWizardAction.EDIT, !isEdit);
    this.wizard.setActionVisible(BPProfileWizardAction.SAVE, isEdit);
    this.wizard.setActionVisible(BPProfileWizardAction.CANCEL, isEdit);
    this.onDisableProfileSelection(isEdit);
  };

  private onToggleEdit = (isEdit:boolean):void => {
    this.bpProfilesService.editingMode = isEdit;
  };

  private saveButtonBusyFunction = (busy:boolean):void => {
    this.wizard.setActionBusy(BPProfileWizardAction.SAVE, busy);
    this.wizard.setActionEnabled(BPProfileWizardAction.CANCEL, !busy);

    if (!busy && this.wizardSaving) {
      this.onToggleEdit(busy);
      this.wizardSaving = false;
    }

    // 'beforeStepChangeDeferred' will only be available when edit confirmation dialog shown
    if (!busy && this.confirmationDialogDeferred) {
      this.confirmationDialogDeferred.resolve(false);

      if (this.confirmationDialog) {
        this.confirmationDialog.hide();
      }
    }
  };

  private onCancel = ():void => {
    this.onToggleEdit(false);
    this.bpProfilesService.onCancel.emit();
  };

  private onSave = ():void => {
    this.wizardSaving = true;
    this.bpProfilesService.onSave.emit();
  };

  private onSavingError = ():void => {
    this.wizardSaving = false;
  };

  private goToSetupWizard = ():void => {
    const wizardState:string = this.uiRouterStateService.current.data?.wizardState || STATE_BPWIZARD_GENERAL;
    this.uiRouterStateService.go(wizardState, {
      profileId: this.profileId
    });
  };

  private onPrintOverviewClick = ():void => {
    const reportDialog:IDialog = this.messageService.showDialog({
      component: BPProfilesReportDialogComponent,
      inputs: {
        profileId: this.profileId,
        companyCountryId: this.bpProfilesService.activeProfile?.companyCountryId
      },
      outputs: {
        onClose: () => reportDialog.hide()
      },
      size: DialogSize.MD,
      wrapperComponent: false
    });
  };

  private onActivationFormClick = ():void => {
    this.window.open(this.urlService.getSupplierActivationFormUrl(<number>this.profileId), '_blank');
  };

  public ngOnDestroy():void {
    this.eventSubscription?.unsubscribe();
    this.onActiveProfileChangeSubscription?.unsubscribe();
    this.onSaveBusySubscription?.unsubscribe();
    this.onEditChangeSubscription?.unsubscribe();
    this.onDisableProfileSelectionSubscription?.unsubscribe();
    this.onSavingErrorSubscription?.unsubscribe();
    this.onStateSuccessHandler();
    this.wizard.clear();
    this.bpProfilesDataService.clear();
    this.responsiveService.width = MaxWidth.SM;
  }
}